<h1 mat-dialog-title>{{ 'labels.heading.Delete' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'labels.text.Are you sure you want to delete' | translate }} {{ data.deleteContext }} ?</p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ delete: true }">
    {{ 'labels.buttons.Confirm' | translate }}
  </button>
</mat-dialog-actions>
